import React from "react";
import {
    Card,
    CardHeader,
    Divider,
    Stack
} from "@mui/material";

import SessionDetailsPanel from "./SessionDetailsPanel";
import TimeslotHeader from "./TimeslotHeader";
import UnbookedTimeslotDetails from "./UnbookedTimeslotDetails";
import ChildAssessmentStrip from "./ChildAssessmentStrip";
import {useSessionLaunch} from "../../hooks/useSessionLaunch";
import {NO_UPCOMING_SESSIONS_MESSAGE} from "../../helpers/SessionHelper";

export default function TimeslotDetailsCard({ selectedEvent, serviceTypeDetails, currentTime, onCardClose, style={}, onPdfClick }) {

    const FIRST_BOOKING_ID = 0;
    const {handleSessionLaunch} = useSessionLaunch(selectedEvent);

    const hasSession = !!selectedEvent?.isTeachingSession;
    const showBookingAssessmentStrip = selectedEvent?.contents.some(content => content.isAssessed);
    const bookingId = selectedEvent?.seats[FIRST_BOOKING_ID]?.booking?.id;

    const eventStyle = {
        p: 1,
        backgroundColor: '#f2f8ff', 
        display: "flex",
        gap: "1rem",
        flexWrap: "wrap",
        ...style
    }

    return (
      <>
          {
            !selectedEvent
            &&
            <Card sx={{p: 5, backgroundColor: '#f2f8ff'}}>
                <CardHeader title={NO_UPCOMING_SESSIONS_MESSAGE}/>
            </Card>
          }
          {
            selectedEvent
            &&
            <Stack container sx={eventStyle}>
                <TimeslotHeader {...{selectedEvent, serviceTypeDetails}} handleHeaderClose={onCardClose}/>
                {hasSession && <SessionDetailsPanel {...{selectedEvent, serviceTypeDetails, currentTime, handleSessionLaunch, onPdfClick}}/>}
                {!hasSession && <UnbookedTimeslotDetails selectedEvent={selectedEvent}/>}
            </Stack>
          }
          {
            showBookingAssessmentStrip && bookingId
            &&
            <>
                <Divider/>
                <ChildAssessmentStrip bookingId={bookingId}/>
            </>
          }
      </>
    );
}